export default function Guarantee() {
  const scrollToHowItWorks = () => {
    const element = document.getElementById('how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="guarantee" className="bg-[#FF6B4A] py-20">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="text-white/80 text-sm font-bold tracking-widest uppercase mb-4">
          OUR IRON-CLAD GUARANTEE
        </div>

        <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4 font-serif">
          30 Clients in 60 Days
        </h2>

        <p className="text-3xl lg:text-4xl text-white font-semibold mb-16">
          Or We Write You a $1,000 Check
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-4xl text-[#FF6B4A]"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">No Long-Term Contracts</h3>
            <p className="text-white/80 text-lg">Month-to-month. Cancel anytime.</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-calendar-line text-4xl text-[#FF6B4A]"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">60-Day Guarantee Period</h3>
            <p className="text-white/80 text-lg">We track every single lead delivered</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-money-dollar-circle-line text-4xl text-[#FF6B4A]"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">$1,000 Cash Guarantee</h3>
            <p className="text-white/80 text-lg">Not credit. Real money in your account.</p>
          </div>
        </div>

        <button
          onClick={scrollToHowItWorks}
          className="border-2 border-white text-white px-10 py-4 rounded-lg text-lg font-bold hover:bg-white hover:text-[#FF6B4A] transition-all whitespace-nowrap cursor-pointer"
        >
          See How It Works ↓
        </button>
      </div>
    </section>
  );
}
